export default __webpack_public_path__ + "static/media/sonata-crm-TN.2a9c15d0.png";